import { Pipe, PipeTransform } from '@angular/core';
import { ContactBase } from '@shared/api/api-loop/models/contact-base';
import { isUserContact } from '@shared/modules/contacts/common/helpers/is-user-contact';

@Pipe({
  name: 'contactsInformation',
  standalone: false
})
export class ContactsInformationPipe implements PipeTransform {
  transform(contacts?: ContactBase[]): { displayName?: string; email?: string; contact: ContactBase }[] | null {
    if (!contacts || !contacts.length) {
      return null;
    }
    return (contacts || []).map(contact => {
      if (isUserContact(contact)) {
        return {
          displayName: contact.displayName ?? contact.name,
          email: contact.email,
          contact: contact
        };
      }

      return {
        displayName: contact.name,
        contact: contact
      };
    });
  }
}
